/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Checkboxes_Pastgiveaways1Inputs */

const id_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway Sebelumnya`)
};

const ms_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberian Lepas`)
};

const da_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidligere Giveaways`)
};

const de_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergangene Giveaways`)
};

const en_us2_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Giveaways`)
};

const es_es2_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos pasados`)
};

const es_mx2_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos anteriores`)
};

const fil_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Nakaraang Giveaway`)
};

const fr_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anciennes gratuités`)
};

const it_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway passati`)
};

const hu_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korábbi ajándékok`)
};

const nl_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerdere giveaways`)
};

const no_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidligere giveaways`)
};

const pl_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednie rozdania`)
};

const pt_br2_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brindes anteriores`)
};

const pt_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas grátis anteriores`)
};

const ro_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte gratuite anterioare`)
};

const fi_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aikaisemmat ilmaisjaot`)
};

const sv_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidigare utlottningar`)
};

const vi_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tặng miễn phí`)
};

const tr_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçmiş Bedava Oyunlar`)
};

const cs_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minulé výprodeje`)
};

const bg_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишни безплатни игри`)
};

const ru_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошедшие раздачи`)
};

const uk_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минулі роздачі`)
};

const ar_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهدايا السابقة`)
};

const hi_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले गिवअवे`)
};

const th_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของแจกฟรีในอดีต`)
};

const ja_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去の配布`)
};

const zh_cn2_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`往期赠送`)
};

const zh_hant1_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`往期贈送`)
};

const ko_search_checkboxes_pastgiveaways1 = /** @type {(inputs: Search_Checkboxes_Pastgiveaways1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지난 무료 배포`)
};

/**
* | output |
* | --- |
* | "Past Giveaways" |
*
* @param {Search_Checkboxes_Pastgiveaways1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_checkboxes_pastgiveaways1 = /** @type {((inputs?: Search_Checkboxes_Pastgiveaways1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Checkboxes_Pastgiveaways1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "ms") return ms_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "da") return da_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "de") return de_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "en-US") return en_us2_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "es-ES") return es_es2_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "es-MX") return es_mx2_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "fil") return fil_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "fr") return fr_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "it") return it_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "hu") return hu_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "nl") return nl_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "no") return no_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "pl") return pl_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "pt-BR") return pt_br2_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "pt") return pt_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "ro") return ro_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "fi") return fi_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "sv") return sv_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "vi") return vi_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "tr") return tr_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "cs") return cs_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "bg") return bg_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "ru") return ru_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "uk") return uk_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "ar") return ar_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "hi") return hi_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "th") return th_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "ja") return ja_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_checkboxes_pastgiveaways1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_checkboxes_pastgiveaways1(inputs)
	return ko_search_checkboxes_pastgiveaways1(inputs)
});
export { search_checkboxes_pastgiveaways1 as "search.checkboxes.pastGiveaways" }